import type { EchartsConfig } from '../../../../../../libs/commons/src';

export const echartsDefaultValue: EchartsConfig = {
  // Grid settings
  gridHeight: 180,
  gridBaseHeight: 150,
  gridGapLaneZoom: 150,
  gridGapBase: 75,
  gridGap: 40,
  gridPaddingTop: 180,
  gridLeftPadding: 170,
  gridRightPadding: 10,
  gridZoomLevelOffset: 65,
  gridLaneOffsetValue: 10,
  gridWidthPercentage: 85,
  gridShow: true,
  gridShowBorder: false,
  gridBackgroundColor: 'transparent',
  gridBorderColor: '#ccc',
  gridBorderWidth: 1,
  gridContainLabel: false,

  // Title settings
  titleOffset: 20,
  titleFontSize: 12,
  titleLeft: 50,
  titleShow: true,
  titleFontWeight: 'lighter',
  titleFontFamily: 'Roboto',
  titleColor: '#333',
  titleAlign: 'center',

  // X-Axis settings
  xAxisShowLine: true,
  xAxisLineColor: '#333',
  xAxisLineWidth: 1,
  xAxisShowTicks: true,
  xAxisTickLength: 5,
  xAxisShowLabels: true,
  xAxisLabelFontSize: 12,
  xAxisLabelColor: '#333',
  xAxisLabelRotate: 0,
  xAxisShowSplitLine: true,
  xAxisSplitLineColor: '#eee',
  xAxisSplitLineType: 'solid',

  // Y-Axis settings
  yAxisOffsetBase: 50,
  yAxisSplitNumber: 2,
  yAxisBoundaryGap: 20,
  yAxisNameGap: 25,
  yAxisShowLine: true,
  yAxisLineColor: '#333',
  yAxisLineWidth: 1,
  yAxisFocusedColor: '#ffa026',
  yAxisFocusedWidth: 2,
  yAxisShowLabels: true,
  yAxisLabelFontSize: 12,
  yAxisLabelColor: '#333',
  yAxisLabelPrecision: 3,
  yAxisShowSplitLine: true,
  yAxisSplitLineColor: '#eee',
  yAxisSplitLineType: 'solid',

  // Zoom slider settings
  zoomSliderShow: true,
  zoomSliderHeight: 30,
  zoomSliderRealtime: true,
  zoomSliderShowDataShadow: false,
  zoomSliderBrushSelect: true,
  zoomSliderHandleColor: '#00893D',
  zoomSliderFillerColor: 'rgba(0, 137, 61, 0.12)',
  zoomSliderBorderColor: 'rgba(100, 100, 100, 0.12)',
  zoomSliderBackgroundColor: 'transparent',
  zoomSliderMoveOnMouseMove: true,
  zoomSliderZoomOnMouseWheel: false,
  zoomSliderThrottle: 100,

  // Series settings
  seriesLineWidth: 2,
  seriesSmooth: true,
  seriesSymbol: 'circle',
  seriesSymbolSize: 2,
  seriesShowSymbol: true,
  seriesLineOpacity: 1,
  seriesAreaOpacity: 0,
  seriesLineType: 'solid',
  seriesConnectNulls: false,
  seriesClip: true,
  seriesSampling: 'none',

  // Animation settings
  animationEnabled: true,
  animationDuration: 1000,
  animationEasing: 'cubicOut',
};
